import { observer } from 'mobx-react-lite';

import { Card } from '@components/card';
import { Stack } from '@components/stack';

import { IntegrationField } from 'components/IntegrationField';
import { IntegrationHeader } from 'components/IntegrationHeader';
import { Loading } from 'components/Loading';

export const EloomiMonitorOnboarding = observer(({ integration }) => {
  integration.loadForApplication();
  return (
    <Stack space={6}>
      <IntegrationHeader integration={integration} />
      {integration.state === 'loading' && <Loading />}
      {integration.state !== 'loading' && (
        <Card space={6}>
          <Stack space={4}>
            {integration.data.map((data, i) => (
              <IntegrationField data={data} key={i} readOnly />
            ))}
          </Stack>
        </Card>
      )}
    </Stack>
  );
});
